<div class="flex flex-col">
  <mat-label class="flex flex-row items-center gap-2">
    {{ label | translate }}
    <span *ngIf="required">*</span>
    <app-icon
      *ngIf="infoTooltip"
      class="cursor-pointer"
      [matTooltip]="infoTooltip | translate"
      iconName="info"
      size="sm"
      fill="#1f5792"
      matTooltipPosition="above"></app-icon>
  </mat-label>
  <mat-form-field>
    <input
      matInput
      [matDatepicker]="picker"
      [value]="value"
      [disabled]="disabled"
      [min]="dateRangeValidation?.minDate?.toJSDate()"
      [max]="dateRangeValidation?.maxDate?.toJSDate()"
      [placeholder]="placeholder | translate"
      (dateChange)="onDateChanged($event.value)" />

    <button class="absolute right-8" mat-icon-button matSuffix type="button" (click)="clearDatePicker()" *ngIf="!disabled">
      <mat-icon>clear</mat-icon>
    </button>

    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
</div>
